import { render, staticRenderFns } from "./TicketModal.vue?vue&type=template&id=bba300f4&"
import script from "./TicketModal.vue?vue&type=script&lang=js&"
export * from "./TicketModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports